import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_find_status_change_task_for_lotService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lot_id: number }): 
  Promise<{ result: { Id?: number, LotId?: number, Notes?: string, OperationCodeId?: number, StatusId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lot_id)) {
      $missingRequiredInParams.push('\'lot_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lot_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LotId?: number, Notes?: string, OperationCodeId?: number, StatusId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lot_id)) {
      $missingRequiredInParams.push('\'lot_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lot_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LotId?: number, Notes?: string, OperationCodeId?: number, StatusId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lot_id)) {
      $missingRequiredInParams.push('\'lot_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lot_id: number    }) {
        if(isNil($inParams.lot_id)) {
          return true; 
        }
      return false;
    }
}
